"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckboxDirection = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var Checkbox_1 = __importDefault(require("./Checkbox"));
var CheckboxDirection;
(function (CheckboxDirection) {
    CheckboxDirection[CheckboxDirection["VERTICAL"] = 0] = "VERTICAL";
    CheckboxDirection[CheckboxDirection["HORIZONTAL"] = 1] = "HORIZONTAL";
})(CheckboxDirection = exports.CheckboxDirection || (exports.CheckboxDirection = {}));
var CheckboxGroup = function (_a) {
    var options = _a.options, value = _a.value, onChange = _a.onChange, className = _a.className, disabled = _a.disabled, direction = _a.direction;
    var valueAsList = value || [];
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)("ui-theme ui-checkbox-group", disabled && 'disabled', direction === CheckboxDirection.HORIZONTAL && 'ui-checkbox-group-horizontal', className) }, options.map(function (o, i) { return (react_1.default.createElement("div", { key: o.divider ? "divider-".concat(i) : o.value }, o.divider ? (react_1.default.createElement("hr", { className: "ui-checkbox-group-divider" })) : (react_1.default.createElement(Checkbox_1.default, { label: o.label, checked: valueAsList.includes(o.value), onChange: function () { return onChange(o, valueAsList.includes(o.value)
            ? valueAsList.filter(function (v) { return v !== o.value; })
            : __spreadArray(__spreadArray([], __read(valueAsList), false), [o.value], false)); }, disabled: disabled || o.disabled })))); })));
};
exports.default = CheckboxGroup;
